/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-05 12:08:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-06 12:37:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/ProductSet/tools/convertDatafromServer.ts
 */
import { ProductItem } from 'src/types/common/product';
import { randomNumber, reduxUpdatedStatusControl } from 'src/tools/helper';

export const convertDatafromServer = (data: ProductItem, priceTiers) => {
  const {
    sku,
    name,
    measurementUnit,
    remarks,
    codes,
    description,
    brand,
    barcode,
    // salesChannelQuotas = [],
    dangerousGoodsClasses,
  } = data;

  // const salesChannelAvailableQuantity = salesChannelQuotas.map((i) => {
  //   const { name, salesChannelUuid, channelType, availableQuantity } = i;
  //   return {
  //     name,
  //     type: channelType,
  //     quantity: availableQuantity || 0,
  //     uuid: salesChannelUuid,
  //   };
  // });
  // const salesChannelAvailablePresaleQuantity = salesChannelQuotas.map((i) => {
  //   const { name, salesChannelUuid, channelType, presaleQuantity } = i;
  //   return {
  //     name,
  //     type: channelType,
  //     quantity: presaleQuantity || 0,
  //     uuid: salesChannelUuid,
  //   };
  // });
  const subCollapseOpen = {};
  const productInfo = {
    sku,
    name,
    measurementUnit,
    remarks,
    codes,
    description,
    brand,
    barcode,
    dangerousGoodsClasses,
  };
  const {
    storeUuid,
    status,
    uuid,
    productStorage,
    productType,
    thumbnailImage,
    defaultCurrency,
  } = data;
  const { tags: innerTags } = data;
  const tags = { tags: innerTags };
  //const { quotaEnabled, inventoryQuota, stockQuantity, stockAvailable } = data;
  // const stock = { quotaEnabled, inventoryQuota, stockQuantity, stockAvailable };
  const { defaultSalePrice, taxRule, cost } = data;
  const priceSettings = {
    defaultSalePrice,
    taxRule,
    cost,
  };
  const { dimensions } = data;
  const { customsInformation } = data;
  const { items = [] } = customsInformation || {};
  const customsInformationItems = items.map((i) => {
    return { ...i, key: randomNumber() };
  });
  //==

  const { productSet } = data;
  const { items: oriProductSetItems = [] } = productSet || {};
  const productSetItems = oriProductSetItems.map((i) => {
    const { product } = i;
    const { uuid } = product || {};
    return {
      ...i,
      uuid,
    };
  });

  const { productSetPriceSettings = [] } = data;
  const _advancedPriceSettings = productSetPriceSettings.map((i) => {
    return { ...i, key: randomNumber() };
  });
  const advancedPriceSettingsInUuid = _advancedPriceSettings.map(
    (i) => i.priceTierUuid,
  );
  const yetTiers = (priceTiers || []).filter(
    (i) => !advancedPriceSettingsInUuid.includes(i.uuid),
  );
  const advancedPriceSettings = [
    ..._advancedPriceSettings,
    ...yetTiers.map((i) => {
      const { uuid, ...rest } = i;
      return {
        ...rest,
        priceTierUuid: uuid,
        key: randomNumber(),
        items: productSetItems.map((i) => {
          return {
            unitPrice: 0,
            noOfUnit: (i || {}).noOfUnit,
            productName: ((i || {}).product || {}).name,
            productUuid: ((i || {}).product || {}).uuid,
            key: randomNumber(),
          };
        }),
      };
    }),
  ];

  //==

  return {
    productInfo,
    storeUuid,
    status,
    uuid,
    productStorage,
    productType,
    thumbnailImage,
    defaultCurrency,
    tags,
    //stock,
    priceSettings,
    advancedPriceSettings,
    dimensions,
    customsInformationItems,
    productSetItems,
    subCollapseOpen,
    // salesChannelAvailableQuantity: salesChannelAvailableQuantity,
    // salesChannelAvailablePresaleQuantity: salesChannelAvailablePresaleQuantity,
    ...reduxUpdatedStatusControl,
  };
};
